/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import { AlarmSourceService } from './AlarmSourceService';

class AlarmSourceServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new AlarmSourceService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { AlarmSourceServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/service/AlarmSourceServiceProvider.js